module.exports = {"120105001":"光复道街道","120105002":"望海楼街道","120105003":"鸿顺里街道","120105004":"新开河街道","120105005":"铁东路街道","120105006":"建昌道街道","120105007":"宁园街道","120105008":"王串场街道","120105009":"江都路街道","120105010":"月牙河街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/120105.json
// module id = 44
// module chunks = 0